import React from 'react';

export interface UseItemViewParams {
  onDuplicate: (index: number) => void;
  onRemove: (index: number) => void;
}

export interface UseItemViewResult {
  isMenuOpen: boolean;
  anchorEl: any;
  onMoreOptionsClick: (e: any) => void;
  onMenuClose: () => void;
  onDuplicateClick: (index: number) => void;
  onRemoveClick: (index: number) => void;
}

export const useItemView = ({
  onDuplicate,
  onRemove
}: UseItemViewParams): UseItemViewResult => {
  const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<any>();

  const onMoreOptionsClick = (e: any) => {
    if (!isMenuOpen) {
      setAnchorEl(e.currentTarget);
      setIsMenuOpen(true);
    }
  };

  const onMenuClose = () => {
    setIsMenuOpen(false);
  };

  const onDuplicateClick = (index: number) => {
    setIsMenuOpen(false);
    onDuplicate(index);
  };

  const onRemoveClick = (index: number) => {
    setIsMenuOpen(false);
    onRemove(index);
  };

  return {
    isMenuOpen,
    anchorEl,
    onMoreOptionsClick,
    onMenuClose,
    onDuplicateClick,
    onRemoveClick
  };
};
